<template>
    <NuxtLayout name="main" :dark="true">
        <div class="container pt-[80px] text-[14px] leading-[30px]">
            <section class="text-[36px] text-emphas leading-[52px] font-bold">{{ $t("AAVCapsidViability") }}</section>
            <section class="mt-[64px]">
                <div :class="clsxs.common.name">{{ $t("RNASplicerManual.M1.H1") }}</div>
                <div :class="clsxs.common.content">
                    <div class="text-emphas">{{ $t("AAVCapsidViabilityManual.M1.D1") }}</div>
                </div>
            </section>

            <section class="mt-[72px]">
                <div :class="clsxs.common.name">{{ $t("AAVCapsidViabilityManual.M2.H1") }}</div>
                <div :class="clsxs.common.content">
                    <div>{{ $t("AAVCapsidViabilityManual.M2.D1") }}</div>
                    <div class="t-border-uicolor4 rounded-[4px] py-[24px] mt-[40px]"><img class="mx-auto max-w-full object-cover" v-src="1" /></div>
                    <div class="mt-[24px] text-center">{{ $t("AAVCapsidViabilityManual.M2.D2") }}</div>

                    <div class="mt-[40px]">
                        <div class="text-[18px] text-emphas leading-[34px] font-bold">{{ $t("AAVCapsidViabilityManual.M2.H2-1") }}</div>
                        <div class="mt-[16px]">
                            <div class="font-bold text-emphas">{{ $t("AAVCapsidViabilityManual.M2.H4-1") }}</div>
                            <div class="flex items-start">
                                <div class="w-[4px] h-[4px] mt-[13px] rounded-[50%] bg-default"></div>
                                <div class="flex-1 ml-[12px]">{{ $t("AAVCapsidViabilityManual.M2.D3") }}</div>
                            </div>
                        </div>

                        <div class="mt-[16px]">
                            <div class="font-bold text-emphas">{{ $t("AAVCapsidViabilityManual.M2.H4-2") }}</div>
                            <div class="flex items-start">
                                <div class="w-[4px] h-[4px] mt-[13px] rounded-[50%] bg-default"></div>
                                <div class="flex-1 ml-[12px]">{{ $t("AAVCapsidViabilityManual.M2.D4") }}</div>
                            </div>

                            <div class="flex items-start">
                                <div class="w-[4px] h-[4px] mt-[13px] rounded-[50%] bg-default"></div>
                                <div class="flex-1 ml-[12px]">{{ $t("AAVCapsidViabilityManual.M2.D5") }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="mt-[40px]">
                        <div class="text-[18px] text-emphas leading-[34px] font-bold">{{ $t("AAVCapsidViabilityManual.M2.H2-2") }}</div>
                        <div class="mt-[16px]">
                            <div class="font-bold text-emphas">{{ $t("AAVCapsidViabilityManual.M2.H4-3") }}</div>
                            <div class="flex items-start">
                                <div class="w-[4px] h-[4px] mt-[13px] rounded-[50%] bg-default"></div>
                                <div class="flex-1 ml-[12px]">{{ $t("AAVCapsidViabilityManual.M2.D6") }}</div>
                            </div>

                            <div class="flex items-start">
                                <div class="w-[4px] h-[4px] mt-[13px] rounded-[50%] bg-default"></div>
                                <div class="flex-1 ml-[12px]">{{ $t("AAVCapsidViabilityManual.M2.D7") }}</div>
                            </div>
                        </div>

                        <div class="mt-[16px]">
                            <div class="font-bold text-emphas">{{ $t("AAVCapsidViabilityManual.M2.H4-2") }}</div>
                            <div class="flex items-start">
                                <div class="w-[4px] h-[4px] mt-[13px] rounded-[50%] bg-default"></div>
                                <div class="flex-1 ml-[12px]">{{ $t("AAVCapsidViabilityManual.M2.D8") }}</div>
                            </div>

                            <div class="flex items-start">
                                <div class="w-[4px] h-[4px] mt-[13px] rounded-[50%] bg-default"></div>
                                <div class="flex-1 ml-[12px]">{{ $t("AAVCapsidViabilityManual.M2.D9") }}</div>
                            </div>
                        </div>
                    </div> -->

                    <div class="mt-[32px] flex items-center">
                        <img src="./src/images/star.webp" alt="Star" />
                        <div class="ml-[4px]">{{ $t("AAVCapsidViabilityManual.M2.D10") }}</div>
                    </div>
                </div>
            </section>

            <section class="mt-[72px]">
                <div :class="clsxs.common.name">{{ $t("AAVCapsidViabilityManual.M3.H1") }}</div>
                <div :class="clsxs.common.content">
                    <i18n-t scope="global" keypath="AAVCapsidViabilityManual.M3.D1">
                        <template v-slot:emphas>
                            <span class="font-bold text-emphas">{{ $t("AAVCapsidViabilityManual.M3.D2") }}</span>
                        </template>
                    </i18n-t>
                    <table class="mt-[40px] text-emphas text-center border-collapse border-spacing-0">
                        <thead>
                            <tr>
                                <th class="bg-uicolor4/30 h-[48px] w-[280px]">sequence</th>
                                <th class="bg-uicolor4/30 h-[48px] w-[280px]">score</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="t-border-color4 h-[48px] w-[280px]">AAV2 WT</td>
                                <td class="t-border-color4 h-[48px] w-[280px]">1.13</td>
                            </tr>
                            <tr>
                                <td class="t-border-color4 h-[48px] w-[280px] bg-color4 text-main">input sequences</td>
                                <td class="t-border-color4 h-[48px] w-[280px] bg-color4 text-main">prediction score</td>
                            </tr>
                            <!-- <tr>
                                <td class="t-border-color4 h-[48px] w-[280px] bg-color4 text-main">AAV9 WT</td>
                                <td class="t-border-color4 h-[48px] w-[280px] bg-color4 text-main">1.02</td>
                            </tr>
                            <tr>
                                <td class="t-border-color4 h-[48px] w-[280px]">input sequences</td>
                                <td class="t-border-color4 h-[48px] w-[280px]">prediction score</td>
                            </tr> -->
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* Vue
import type { Directive } from "vue";
//* 组件属性
import { clsxs } from "./src/clsx";
//* 图片资源导入
const images = import.meta.glob("./src/images/*/*.bmp", { query: "url", import: "default" });
//* 插件
const i18n = useI18n();
//* 指令
const vSrc: Directive<HTMLImageElement, string | number> = {
    created: (_node, response, vnode) => {
        images[`./src/images/${i18n.locale.value}/${response.value.toString()}.bmp`]?.().then((src) => {
            vnode.el.src = src;
        });
    },
};
</script>
